<template>
  <div class="user-component-list frame-content-common dashboard_index">
    <breadcrumb :name="goLang('Dashboard')" :img="img"></breadcrumb>
    <div class="main-dash mt-3" v-if="permissionUser.user_type != 3">
      <div class="content-w">
        <p class="title-line">{{ goLang('Vị trí hàng hóa trong kho ') }}</p>
        <div class="list_location">
          <div class="location_item" v-for="item in arr_area" :key="item.id" :style="{background: item.bg}">
            <div class="d-flex-bw mb-3 ">
              <span class="txt_name_l" :style="{color: item.color}">{{ item.name }}</span>
              <img src="@/static/icon/dash/layer.svg" alt="">
            </div>
            <div class="d-flex-bw">
              <span class="txt" :style="{color: item.color}">{{ goLang('Tổng pallet') }}</span>
              <span class="num" :style="{color: item.color}">{{ item.total_pallet }}</span>
            </div>
            <div class="d-flex-bw">
              <span class="txt" :style="{color: item.color}">{{ goLang('Tổng bao') }}</span>
              <span class="num" :style="{color: item.color}">{{ item.total_bag }}</span>
            </div>
            <div class="d-flex-bw">
              <span class="txt" :style="{color: item.color}">{{ goLang('Trọng lượng') }} KG</span>
              <span class="num" :style="{color: item.color}">{{ item.total_weight | numberWeight }}</span>
            </div>
            <div class="d-flex-bw">
              <span class="txt" :style="{color: item.color}">{{ goLang('Thể tích') }} M3</span>
              <span class="num" :style="{color: item.color}">{{ item.total_volume | numberVolume }}</span>
            </div>
          </div>
        </div>
      </div>
      <!--      // xe -->
      <div class="d-flex my-3 car-info">
        <div class="content-w mr-2" style="width: 47%">
          <div class="line-1 d-flex align-items-center justify-content-between">
            <span class="title">{{ goLang('Xe Trung Quốc') }}</span>
            <el-select v-model="status_car_cn" placeholder="Select" size="mini" @change="changeStatusCar(1)">
              <el-option
                v-for="item in listStatusCar"
                :key="item.status"
                :label="item.name"
                :value="item.status">
              </el-option>
            </el-select>
          </div>
          <div class="list_car" v-loading="loadingCN">
            <div class="car_item" v-for="item in arr_car_cn" :key="item.id" >
              <div class="d-flex-bw mb-3">
                <div class="icon-car">
                  <img src="@/static/icon/dash/carr.svg" alt="">
                </div>
                <span class="status_name" :style="{background: item.status_color}">{{ item.status_text }}</span>
              </div>
              <div class="d-flex-bw">
                <span class="txt-info font700">{{ item.contact_person }}</span>
                <span class="num car_n" style="color: #0C91DF">{{ item.car_number }}</span>
              </div>
              <div class="d-flex-bw">
                <span class="txt-info">{{ goLang('Tổng pallet') }}</span>
                <span class="num">{{ item.total_pallet }}</span>
              </div>
              <div class="d-flex-bw">
                <span class="txt-info">{{ goLang('Tổng bao') }}</span>
                <span class="num">{{ item.total_bag }}</span>
              </div>
              <div class="d-flex-bw">
                <span class="txt-info">{{ goLang('Trọng lượng') }} KG</span>
                <span class="num">{{ item.total_weight | numberWeight }}</span>
              </div>
              <div class="d-flex-bw">
                <span class="txt-info">{{ goLang('Thể tích') }} M3</span>
                <span class="num">{{ item.total_volume | numberVolume }}</span>
              </div>
              <div class="d-flex-bw">
                <span class="txt-info">{{ goLang('Ngày') }}</span>
                <span class="num">{{ item.created_at }}</span>
              </div>
            </div>
            <div v-if="arr_car_cn.length == 0" style="text-align: center; width: 100%; padding-top: 50px; font-size: 12px"  >
              <span>{{ goLang('Không có dữ liệu') }}</span>
            </div>
          </div>
        </div>
        <div class="content-w ml-2" style="width: 45%;">
          <div class="line-1 d-flex align-items-center justify-content-between">
            <span class="title">{{ goLang('Xe Việt Nam') }} </span>
            <el-select v-model="status_car_vn" placeholder="Select" size="mini" @change="changeStatusCar(2)">
              <el-option
                v-for="item in listStatusCarVN"
                :key="item.status"
                :label="item.name"
                :value="item.status">
              </el-option>
            </el-select>
          </div>
          <div class="list_car" v-loading="loadingVN">
            <div class="car_item" v-for="item in arr_car_vn" :key="item.id">
              <div class="d-flex-bw mb-3">
                <div class="icon-car">
                  <img src="@/static/icon/dash/carr.svg" alt="">
                </div>
                <span class="status_name" :style="{background: item.status_color}">{{ item.status_text }}</span>
              </div>
              <div class="d-flex-bw">
                <span class="txt-info font700">{{ item.contact_person }}</span>
                <span class="num car_n" style="color: #0C91DF">{{ item.car_number }}</span>
              </div>
              <div class="d-flex-bw">
                <span class="txt-info">{{ goLang('Tổng pallet') }}</span>
                <span class="num">{{ item.total_pallet }}</span>
              </div>
              <div class="d-flex-bw">
                <span class="txt-info">{{ goLang('Tổng bao') }}</span>
                <span class="num">{{ item.total_bag }}</span>
              </div>
              <div class="d-flex-bw">
                <span class="txt-info">{{ goLang('Trọng lượng') }} KG</span>
                <span class="num">{{ item.total_weight | numberWeight }}</span>
              </div>
              <div class="d-flex-bw">
                <span class="txt-info">{{ goLang('Thể tích') }} M3</span>
                <span class="num">{{ item.total_volume | numberVolume }}</span>
              </div>
              <div class="d-flex-bw">
                <span class="txt-info">{{ goLang('Ngày') }}</span>
                <span class="num">{{ item.created_at }}</span>
              </div>
            </div>
            <div v-if="arr_car_vn.length == 0" style="text-align: center; width: 100%; padding-top: 50px; font-size: 12px">
              <span>{{ goLang('Không có dữ liệu') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import Breadcrumb from "@/components/Breadcrumb.vue";
  import AuthLogin from "@/AuthLogin";
  import axios from "axios";
  export default {
    name: "HomeIndex",
    metaInfo() {
      return {
        title: "Onewarehouse",
      };
    },
    components: {
      Breadcrumb
    },
    data() {
      return {
        loading: true,
        img: require("@/static/icon/dash/index.svg"),
        arr_area:[],
        arr_color: [
          {
            color: '#0C91DF',
            bg: '#E8F3FF',
          },
          {
            color: '#C30202',
            bg: '#F2C6DF',
          },
          {
            color: '#CF9500',
            bg: '#FAEDCB',
          },
          {
            color: '#9368FF',
            bg: '#DBCDF0',
          },
          {
            color: '#349C88',
            bg: '#C9E4DF ',
          },
          {
            color: '#B1612A',
            bg: '#F8D9C4',
          },
        ],
        listStatusCar: [],
        listStatusCarVN: [],
        status_car_cn: 1,
        status_car_vn: 2,
        arr_car_cn: [],
        arr_car_vn: [],
        type_car: '',
        status_car: '',
        loadingCN: true,
        loadingVN: true,
      };
    },
    computed: {
      ...mapGetters("account", ["logged", "accountInfo"]),
      ...mapGetters(["permissionUser"]),


    },
    mounted() {
      this.fetchArea();
      this.fetchCarVN();
      this.fetchCarCN();
      this.fetchStatus();
    },
    methods: {
      checkRole(){
        if (!AuthLogin.checkRolePermission('admin.dashboard.index')) {
          this.$notify.error({
            title: "Error",
            message: "Bạn không có quyền truy cập",
          });
          return this.$router.push({ name: "home-index" });
        }
      },
      fetchStatus() {
        axios.get("admin/list-status-car").then((response) => {
          switch (response.data.code) {
            case 200:
              this.listStatusCar = response.data.data.listStatusCar;
              this.listStatusCarVN = this.listStatusCar.filter(item => [2, 4, 5].includes(item.status));
              break;
            default:
              this.$notify.error({
                title: "Error",
                message: this.langByLanguage.api_warning_admin,
              });
              break;
          }
        }).catch(errors => {
          console.log(errors)
        });
      },
      fetchArea() {
        this.loading = true;
        axios.post("dashboard/list-area", ).then((response) => {
          this.loading = false
          switch (response.data.code) {
            case 200:
              // this.arr_area = response.data.data;
              this.arr_area = response.data.data.map((item, index) => {
                const colorIndex = index % this.arr_color.length;
                return {
                  ...item,
                  color: this.arr_color[colorIndex].color,
                  bg: this.arr_color[colorIndex].bg,
                };
              });
              break;
            default:
              this.$notify.error({
                title: "Error",
                message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
              });
              break;
          }
        }).catch( errors => {
          if (errors.response.data.code === 403 || errors.response.data.code === 500) {
            this.$notify({
              title: "Có lỗi xảy ra",
              message: errors.response.data.message,
              type: "warning",
            });
            if(errors.response.data.code === 403){
              return this.$router.push({name: "for-bidden"});
            }
          } else if (errors.response.data.code === 422){
            this.$notify({
              title: "Có lỗi xảy ra",
              message: Object.values(errors.response.data.data)[0],
              type: "warning",
            });
          } else {
            this.$notify({
              title: "Có lỗi xảy ra",
              message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
              type: "warning",
            });
          }
        });
      },

      changeStatusCar (type) {
        if (type == 1) {
          this.fetchCarCN();
        } else {
          this.fetchCarVN();
        }
      },
      fetchCarCN() {
        let data = {
          type: 1,
          status: this.status_car_cn,
        }
        this.loadingCN = true;
        axios.post("dashboard/list-car", data).then((response) => {
          this.loadingCN = false;
          switch (response.data.code) {
            case 200:
              this.arr_car_cn = response.data.data;
              break;
            default:
              this.$notify.error({
                title: "Error",
                message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
              });
              break;
          }
        }).catch( errors => {
          this.loadingCN = false;
          if (errors.response.data.code === 403 || errors.response.data.code === 500) {
            this.$notify({
              title: "Có lỗi xảy ra",
              message: errors.response.data.message,
              type: "warning",
            });
            if(errors.response.data.code === 403){
              return this.$router.push({name: "for-bidden"});
            }
          } else if (errors.response.data.code === 422){
            this.$notify({
              title: "Có lỗi xảy ra",
              message: Object.values(errors.response.data.data)[0],
              type: "warning",
            });
          } else {
            this.$notify({
              title: "Có lỗi xảy ra",
              message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
              type: "warning",
            });
          }
        });
      },
      fetchCarVN() {
        let data = {
          type: 2,
          status: this.status_car_vn,
        }
        this.loadingVN = true;
        axios.post("dashboard/list-car", data).then((response) => {
          this.loadingVN = false;
          switch (response.data.code) {
            case 200:
              this.arr_car_vn = response.data.data;
              break;
            default:
              this.$notify.error({
                title: "Error",
                message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
              });
              break;
          }
        }).catch( errors => {
          this.loadingVN = false;
          if (errors.response.data.code === 403 || errors.response.data.code === 500) {
            this.$notify({
              title: "Có lỗi xảy ra",
              message: errors.response.data.message,
              type: "warning",
            });
            if(errors.response.data.code === 403){
              return this.$router.push({name: "for-bidden"});
            }
          } else if (errors.response.data.code === 422){
            this.$notify({
              title: "Có lỗi xảy ra",
              message: Object.values(errors.response.data.data)[0],
              type: "warning",
            });
          } else {
            this.$notify({
              title: "Có lỗi xảy ra",
              message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
              type: "warning",
            });
          }
        });
      },
    },
    watch: {
    },
  };
</script>


<style lang="css" scoped>
  .main-dash {
    min-height: 500px;
    background: #ffffff;
  }
  .dashboard_index {
    background: #f2fbfe;
  }
  .content-w {
    background: #ffffff;
    padding: 20px;
    border-radius: 5px;
    border: 1px solid #C2E3F7;
  }
  .title-line {
    margin-top: 0;
    font-weight: 600;
    font-size: 14px;
  }
  .list_location {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    gap: 12px;
    padding: 10px 0;
  }
  .location_item {
    /*background: #E8F3FF;
    width: 15%;
    height: 231px;
    border-radius: 5px;
    margin: 10px 10px 10px 0;
    padding: 10px;*/

    background: #E8F3FF;
    min-width: 220px;
    height: 195px;
    border-radius: 5px;
    margin: 10px 10px 10px 0;
    padding: 10px;
    flex-shrink: 0;
  }
  .d-flex-bw {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px  0;
  }
  .d-flex-bw .txt {
    padding: 5px 10px;
    background: #ffffff;
    color: #0C91DF;
    font-size: 12px ;
    border-radius: 5px;
  }
  .d-flex-bw .num {
    font-size: 12px;
    font-weight: 700;
  }
  .txt_name_l {
    font-size: 13px;
    font-weight: 700;
    background: #ffffff;
    border-radius: 5px;
    padding: 5px 10px;
  }
  .car-info .line-1 {
    margin-bottom: 10px;
  }
  .car-info .line-1 .title {
    font-weight: 700;
    font-size: 13px;
  }
  .list_car {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    gap: 12px;
    padding: 10px 0;
  }
  .list_car .d-flex-bw {
    padding: 3px 0 !important;
  }
  .car_item {
    /*width: 30%;*/
    height: 235px;
    border-radius: 5px;
    border: 1px solid #E8F3FF;
    font-size: 12px;

    min-width: 220px;
    height: 231px;
    border-radius: 5px;
    padding: 10px;
    flex-shrink: 0;
  }
  .car_item:hover {
    background: #E8F3FF;
  }
  .icon-car {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #0C91DF;
  }
  .car_item .txt-info {
    padding: 5px 0;
  }
  .font700 {
    font-weight: 700;
  }
  .car_n {
    padding: 5px 10px;
    background: #C2E3F7;
    border-radius: 10px;
  }
  .status_name {
    padding: 5px 10px;
    color: #ffffff;
    border-radius: 5px;
  }
</style>
<style>
  .dashboard_index .bg-breadcrumb  img {
    width: 22px !important;
  }
</style>

